import React from 'react';
import { Group } from 'react-konva';
import { Children } from 'utils/types/react';

export interface WithCursorPointerProps {
  children: Children;
}

function WithCursorPointer(props: WithCursorPointerProps) {
  return (
    <Group
      onMouseEnter={(event) => {
        // @ts-ignore
        const container = event.target.getStage()?.container();
        if (container) {
          container.style.cursor = 'pointer';
        }
      }}
      onMouseLeave={(event) => {
        // @ts-ignore
        const container = event.target.getStage()?.container();
        if (container) {
          container.style.cursor = 'default';
        }
      }}>
      {props.children}
    </Group>
  );
}

export default WithCursorPointer;
